import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Paper,
  Toggle,
  TextField,
  Card,
  CardHeader,
  CardText
} from 'material-ui';

const styles = {
  block: {
    maxWidth: 1024,
    margin: '16px auto',
    padding: 8,
  },
  toggle: {
    marginBottom: 16,
  },
  textField: {
    marginBottom: 8,
  }
};

class FilterClients extends Component {
  static propTypes = {
    onChange: PropTypes.func,
  };

  state = {
    status: 'all', // all | active | inactive
    searchText: '',
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  filter() {
    const { onChange } = this.props;
    const { status, searchText } = this.state;
    onChange && onChange(status, searchText);
  }

  tryFilter() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      this.filter();
      this._timer = null;
    }, 500);
  }

  setStatusFilter = (targetStatus, event) => {
    const { checked } = event.target;
    let newStatus = 'all';

    if (checked) {
      newStatus = targetStatus;
    }

    this.setState({ status: newStatus }, () => {
      this.tryFilter();
    });
  };

  changeSearchText = (event) => {
    const { value } = event.target;
    const { router } = this.context;

    this.setState({ searchText: value }, () => {
      this.tryFilter();
    });

    router.push('/clients');
  };

  render() {
    const { searchText, status } = this.state;

    return (
      <Paper style={styles.block}>
        <TextField
          value={searchText}
          fullWidth
          onChange={this.changeSearchText}
          floatingLabelText="Search by Email or Client ID"
          style={styles.textField}
        />

        <Card>
          <CardHeader
            title="Search by Status"
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <Toggle
              toggled={status === 'active'}
              onToggle={this.setStatusFilter.bind(this, 'active')}
              style={styles.toggle}
              label="Active Clients"
            />
            <Toggle
              toggled={status === 'inactive'}
              onToggle={this.setStatusFilter.bind(this, 'inactive')}
              style={styles.toggle}
              label="Inactive Clients"
            />
          </CardText>
        </Card>
      </Paper>
    );
  }
}

export default FilterClients;
